import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { quoteSearchPageQueryOptions } from "~/app/api/pageData/quoteSearchPageQuery";
import type { QuoteSearchPageInitialData } from "~/app/api/pageData/quoteSearchPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createQuoteListPage, type QuoteListPageProps } from "~/features/orders/quoteList/QuoteListPage";

const QUOTE_SEARCH_PATH = "/quotes";

function QuoteSearchRoute() {
  const result = useLoaderData({
    from: QUOTE_SEARCH_PATH,
  }) as PageInitialData<QuoteSearchPageInitialData>;
  const shellProps = useStorefrontShellProps();
  const pageProps = parsePageData(result.data?.pageDataJson);

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {pageProps ? createQuoteListPage(pageProps) : null}
    </StorefrontShellFrame>
  );
}

function parsePageData(pageDataJson: string | undefined): QuoteListPageProps | null {
  if (!pageDataJson) {
    return null;
  }
  try {
    return JSON.parse(pageDataJson) as QuoteListPageProps;
  } catch {
    return null;
  }
}

export async function loadQuoteSearchPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(quoteSearchPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const quoteSearchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: QUOTE_SEARCH_PATH,
  loader: async ({ context }) => loadQuoteSearchPageData(context),
  component: QuoteSearchRoute,
});
